import { z } from "zod";

export const EmailTemplateAttachmentSchema = z.object({
  fileUuid: z.string(),
  fileName: z.string(),
  contentType: z.string().nullable().optional(),
  fileSize: z.number().nullable().optional(),
  publicUrl: z.string().nullable().optional(),
});

export type EmailTemplateAttachmentValue = z.infer<
  typeof EmailTemplateAttachmentSchema
>;

export const EmailTemplateFormSchema = z.object({
  templateName: z.string().min(1, "Template name is required"),
  emailSubject: z.string().min(1, "Email subject is required"),
  emailContent: z.string().min(1, "Email content is required"),
  categories: z
    .array(
      z.object({
        id: z.number(),
        name: z.string(),
        displayedName: z.string().optional(),
        color: z
          .object({
            id: z.number(),
            value: z.string(),
          })
          .optional(),
      }),
    )
    .min(1, "At least one category must be selected"),
  attachments: z.array(EmailTemplateAttachmentSchema).default([]),
});

export type EmailTemplateFormData = z.infer<typeof EmailTemplateFormSchema>;
